import { render, staticRenderFns } from "./pending-table.vue?vue&type=template&id=b904158a&scoped=true&"
import script from "./pending-table.vue?vue&type=script&lang=js&"
export * from "./pending-table.vue?vue&type=script&lang=js&"
import style0 from "./pending-table.vue?vue&type=style&index=0&id=b904158a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b904158a",
  null
  
)

export default component.exports